import { useGetMyPlansQuery } from "../../api/rtkQueryApi/PlansApi";
import { SalesSummary } from "../../components/commissions/SalesSummary";
import { useCommissionsGetMineQuery } from "../../api/rtkQueryApi/CommissionsApi";

export const GrowthCoachSummary: React.FC = () => {
  const getMyPlansQuery = useGetMyPlansQuery();
  const getMyCommissionsQuery = useCommissionsGetMineQuery();

  return (
    <SalesSummary
      plans={getMyPlansQuery.data ?? []}
      commissions={getMyCommissionsQuery.data ?? []}
      isLoading={getMyPlansQuery.isLoading || getMyCommissionsQuery.isLoading}
    />
  );
};
